import img1 from "../images/agrotop/img1.jpg";
import img2 from "../images/agrotop/img2.jpg";
import img3 from "../images/agrotop/img3.jpg";
import img4 from "../images/agrotop/img4.jpg";
import img5 from "../images/agrotop/img5.jpg";
import img6 from "../images/agrotop/img6.jpg";
import img7 from "../images/agrotop/img7.jpg";

export const imgAgrotop = [
  {
    id: 4101,
    image: img1
  },
  {
    id: 4102,
    image: img2
  },
  {
    id: 4103,
    image: img3
  },
  {
    id: 4104,
    image: img4
  },
  {
    id: 4105,
    image: img5
  },
  {
    id: 4106,
    image: img6
  },
  {
    id: 4107,
    image: img7
  },
  
];